import {
  type DataSourceDefinition,
  type FiltersDefinition,
  type SortingsDefinition,
} from '@factorialco/f0-react'
import { HeadcountLocationSelectorDocument } from 'generated/resources/graphql'
import { type RecordType } from '@factorialco/f0-react'

import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'

export interface LocationOption extends RecordType {
  id: string
  name: string
}

const useHeadcountLocationSource = (): DataSourceDefinition<
  LocationOption,
  FiltersDefinition,
  SortingsDefinition
> => {
  return useGraphqlDataSource(
    {
      document: HeadcountLocationSelectorDocument,
      paginationType: 'infinite-scroll',
      fetchPolicy: 'cache-first',
      perPage: 25,
      search: { enabled: true },
      mapData: (data) =>
        data.locations.locationsConnection.nodes.map(
          (node): LocationOption => ({
            id: node.id,
            name: node.name,
          })
        ),
      mapPagination: (data) => {
        const connection = data.locations.locationsConnection
        return {
          total: connection.totalCount ?? 0,
          cursor: connection.pageInfo.endCursor ?? '0',
          hasNextPage: !!connection.pageInfo.hasNextPage,
        }
      },
      mapVariables: ({ search, pagination }) => ({
        search,
        first: pagination?.perPage ?? 25,
        after:
          pagination?.cursor && pagination.cursor !== '0' ? String(pagination.cursor) : undefined,
      }),
    },
    []
  )
}

export default useHeadcountLocationSource
